module.exports = __webpack_public_path__ + "static/media/sleeping-giants.a2563721.jpg";